exports.components = {
  "component---src-pages-success-js": () => import("./../../../src/pages/success.js" /* webpackChunkName: "component---src-pages-success-js" */),
  "component---src-templates-storyblok-page-js": () => import("./../../../src/templates/storyblok/page.js" /* webpackChunkName: "component---src-templates-storyblok-page-js" */)
}

